import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class ForestersCottageBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.FORESTER_COTTAGE;
}

export default ForestersCottageBuildingTileEntity;
